import ClientCreateModal from "./client-create-modal";

export default ClientCreateModal;
